// extracted by mini-css-extract-plugin
export default {"modelSlider":"ModelSlider_modelSlider__pg5p5","modelCard":"ModelSlider_modelCard__L3ZGC","modelImage":"ModelSlider_modelImage__Z89Co","modelName":"ModelSlider_modelName__Jzc+n"};